<template>
  <b-row>
    <b-col>
      <b-checkbox
        v-model="value.adicionar"
        :disabled="disabled || admin|| portal || semRemocao || painelProposta || todosCampos"
        @change="sendToParent()"
      >
        Adicionar
      </b-checkbox>
    </b-col>
    <b-col>
      <b-checkbox
        v-model="value.visualizar"
        :disabled="disabled || admin || portal || semRemocao || painelProposta || todosCampos"
        @change="habilitaVisualizar"
      >
        Visualizar
      </b-checkbox>
    </b-col>
    <b-col>
      <b-checkbox
        v-model="value.alterar"
        :disabled="disabled || admin || portal || semRemocao || painelProposta || todosCampos"
        @change="sendToParent()"
      >
        Alterar
      </b-checkbox>
    </b-col>
    <b-col>
      <b-checkbox
        v-model="value.remover"
        :disabled="disabled || admin || portal || semRemocao || painelProposta || todosCampos"
        variant="danger"
        @change="sendToParent()"
      >
        Remover
      </b-checkbox>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
      default: () => { },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    admin: {
      type: Boolean,
      default: false,
    },
    portal: {
      type: Boolean,
      default: false,
    },
    semRemocao: {
      type: Boolean,
      default: false,
    },
    todosCampos: {
      type: Boolean,
      default: false,
    },
    painelProposta: {
      type: Boolean,
      default: false,
    },
    alteracao: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    portal(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarPermissaoPortal(value)
      }
    },
    semRemocao(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarPermissaoSemRemocao(value)
      }
    },
    painelProposta(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarPermissaoPainelProposta(value)
      }
    },
    todosCampos(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarPermissaoTodosCampos(value)
      }
    },
    alteracao(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarPermissaoProposta(value)
      }
    },
    disabled(value, oldValue) {
      if (!this.admin && value && value !== oldValue) {
        this.value.adicionar = !value
        this.value.visualizar = !value
        this.value.alterar = !value
        this.value.remover = !value
      }
    },
    admin(value, oldValue) {
      if (value && value !== oldValue) {
        this.value.adicionar = true
        this.value.visualizar = true
        this.value.alterar = true
        this.value.remover = true
      }
    },
    'value.adicionar': function (value, oldValue) {
      if (value !== oldValue && value) {
        this.value.visualizar = true
      }
    },
    'value.alterar': function (value, oldValue) {
      if (value !== oldValue && value) {
        this.value.visualizar = true
      }
    },
    'value.remover': function (value, oldValue) {
      if (value !== oldValue && value) {
        this.value.visualizar = true
      }
    },
  },
  created() {
    if (this.portal) {
      this.aplicarPermissaoPortal(true)
    }
    if (this.semRemocao) {
      this.aplicarPermissaoSemRemocao(true)
    }
    if (this.todosCampos) {
      this.aplicarPermissaoTodosCampos(true)
    }
    if (this.painelProposta) {
      this.aplicarPermissaoPainelProposta(true)
    }
    if (this.alteracao) {
      this.aplicarPermissaoProposta(true)
    }
  },
  methods: {
    aplicarPermissaoPortal(value) {
      this.value.adicionar = false
      this.value.visualizar = value
      this.value.alterar = value
      this.value.remover = false
    },
    aplicarPermissaoSemRemocao(value) {
      this.value.adicionar = value
      this.value.visualizar = value
      this.value.alterar = value
      this.value.remover = false
    },
    aplicarPermissaoTodosCampos(value) {
      this.value.adicionar = value
      this.value.visualizar = value
      this.value.alterar = value
      this.value.remover = value
      this.disabled(true)
    },
    aplicarPermissaoPainelProposta(value) {
      this.value.adicionar = false
      this.value.visualizar = value
      this.value.alterar = false
      this.value.remover = false
    },
    aplicarPermissaoProposta(value) {
      this.value.visualizar = value
    },
    habilitaVisualizar(value) {
      if (!value && (this.value.adicionar || this.value.alterar || this.value.remover)) {
        this.value.visualizar = true
      } else {
        this.value.visualizar = value
      }
      this.sendToParent()
    },
    sendToParent() {
      this.$emit('input', this.value)
    },
  },
}
</script>
